import React, { useState, useEffect } from 'react'
import { compose } from 'recompose'
import { Auth } from 'aws-amplify'
import { Route, Switch, Router, Redirect } from 'react-router-dom'
import { history } from 'config/history'
import { useTranslation } from 'react-i18next'
import get from 'lodash/get'
import { useApolloClient } from '@apollo/client'

import getSections, { getMainNavContent, getMainSectionsRegexp, getBottomSections } from 'sections/sections'
import MediaTest from 'sections/media/pages/MediaTest'
import NavBar from 'components/NavBar'
import SectionHandler from 'components/SectionHandler'
import PageNotFound from 'components/PageNotFound'

import withAuth, { isAdmin } from 'components/withAuth'
import withAppInit from 'components/withAppInit'
import ErrorHandler from 'components/ErrorHandler'
import propsChangeCheck from 'helpers/propsChangeCheck'

import 'react-table/react-table.css'
import 'weather-icons/css/weather-icons.min.css'
import { StyledAppContainer } from './style/styled'
import 'moment/locale/de'
import moment from 'moment'

moment.locale('de')

const App = ({ onStateChange, initData = {}, resetCache, authData, ...rest }) => {
	const client = useApolloClient()
	const [t, i18n] = useTranslation()
	const appData = {
		...get(initData, 'getAppConfig', {}),
		isAdmin: isAdmin(authData),
		authData,
		shopAccess: JSON.parse(authData.attributes['custom:access_shops'] || null)
	}

	const appLanguage = appData.language
	const companyName = appData.isAdmin ? get(initData, 'getAppConfig.name') : null

	if (appLanguage && appLanguage !== i18n.language) {
		i18n.changeLanguage(appLanguage)
	}

	const signOut = async () => {
		await resetCache()
		await Auth.signOut() // sign out user
		onStateChange('signedOut') // goto sign in page
		history.push('/')
	}

	const [accessRights, setAccessRights] = useState([])
	const getRights = async () => {
		const accessCustomRights = JSON.parse((await Auth.currentUserInfo()).attributes?.['custom:access_custom_rights'] || null)?.caw
		if (accessCustomRights) {
			setAccessRights(accessCustomRights?.map(e => e?.split(',')))
		}
	}
	useEffect(() => {
		getRights()
	}, [])

	const bottomSections = getBottomSections({ signOut, companyName, t })

	return (
		<Router history={history}>
			<ErrorHandler client={client}>
				<Switch>
					<Redirect exact from='/' to='/artikel'/>
					<Route exact path='/mediacenter/testen'><MediaTest/></Route>
					<Route path='/'><Main accessRights={accessRights} appData={appData} signOut={signOut} t={t} i18n={i18n} companyName={companyName} bottomSections={bottomSections}/></Route>
				</Switch>
			</ErrorHandler>
		</Router>
	)
}

const Main = ({ appData, t, i18n, bottomSections, accessRights }) => {
	// const [t, i18n] = useTranslation()
	const sections = getSections(t, accessRights, i18n)
	const mainSectionsRegexp = getMainSectionsRegexp(sections)
	const mainNavContent = getMainNavContent(sections, t, appData?.name)
	return (
		<StyledAppContainer>
			<NavBar
				barHeight='mainSections'
				className='main'
				activeBorder
				navContent={mainNavContent}
				id='sectionContent'
			>
				<Switch>
					<Route path={`/:section(${mainSectionsRegexp})/:subsection?/:id?`}>
						<SectionHandler appData={appData} sections={sections} />
					</Route>
					<Route><PageNotFound/></Route>
				</Switch>
			</NavBar>
			<NavBar className='bottomnav' barHeight='bottomNav' navContent={bottomSections}/>
		</StyledAppContainer>
	)
}

export default compose(
	withAuth,
	withAppInit,
	propsChangeCheck(['initData'])
)(App)
